import Nav from '../components/common/Nav';
import Footer from '../components/common/Footer';

export default function Media() {
  const internationalNews = [
    {
      date: '2025-12-19',
      title: 'Netflix acquires gaming avatar maker Ready Player Me',
      url: 'https://techcrunch.com/2025/12/19/netflix-acquires-gaming-avatar-maker-ready-player-me/',
      source: 'TechCrunch - Netflix acquires Ready Player Me to build avatars for subscribers across different games, with team of 20 joining Netflix.'
    },
    {
      date: '2024-12-18',
      title: 'Manchester City announce innovative collaborations with Avatar Creation Platform Ready Player Me',
      url: 'https://sports.yahoo.com/manchester-city-announce-innovative-collaborations-110000445.html',
      source: 'Yahoo! - Partnership announcement with Manchester City for avatar creation in sports metaverse.'
    },
    {
      date: '2022-08-23',
      title: 'Investing in Ready Player Me',
      url: 'https://a16z.com/announcement/investing-in-ready-player-me/',
      source: 'a16z - Andreessen Horowitz announces their investment in Ready Player Me\'s Series B funding round.'
    },
    {
      date: '2022-06-24',
      title: 'Meet the Visionaries Who Are Leveling Up the Metaverse',
      url: 'https://www.samsung.com/nz/explore/brand/meet-the-visionaries-who-are-leveling-up-the-metaverse/',
      source: 'Samsung - Profile of metaverse innovators including Ready Player Me\'s vision for digital identity.'
    },
    {
      date: '2022-01-25',
      title: 'Pixelynx and Ready Player Me to bring selfie-generated 3D avatars to music metaverse',
      url: 'https://www.pocketgamer.biz/pixelynx-and-ready-player-me-partnership/',
      source: 'Pocket Gamers - Partnership announcement for bringing avatars to the music metaverse.'
    },
    {
      date: '2021-07-21',
      title: 'Wolf3D launches Ready Player Me cross-game avatars for the metaverse',
      url: 'https://venturebeat.com/games/wolf3d-launches-ready-player-me-cross-game-avatars-for-the-metaverse/',
      source: 'VentureBeat - Coverage of Ready Player Me\'s launch of cross-game avatar platform.'
    },
    {
      date: '2019-06-06',
      title: 'Three lessons on how foreign entrepreneurs succeed in the U.S.',
      url: 'https://150sec.com/three-lessons-on-how-foreign-entrepreneurs-succeed-in-the-u-s/11388/',
      source: '150sec - Kaspar shares insights on international expansion and building startups in the U.S. market.'
    },
    {
      date: '2019-02-12',
      title: '2019 Europe 30 under 30: Technology',
      url: 'https://www.forbes.com/pictures/5c60c0f2a7ea432d0765b2fe/wolf3d-rainer-selvet-kasp/',
      source: 'Forbes - Named to Forbes 30 Under 30 Europe list in Technology category.'
    }
  ];

  const estonianNews = [
    {
      date: '2025-12-23',
      title: 'Netflix ostis suvepealinlaste idufirma',
      url: 'https://parnu.postimees.ee/8385023/netflix-ostis-suvepealinlaste-idufirma',
      source: 'Pärnu Postimees - Netflix acquired the startup founded by Pärnu residents Timmu Tõke, Kaspar Tiri, Rainer Selvet, and Haver Järveoja.'
    },
    {
      date: '2024-11-13',
      title: 'Eesti müügiidu sai esimese rahasüsti Markus Villigult ja Kaspar Tirilt',
      url: 'https://digipro.geenius.ee/rubriik/uudis/eesti-muugiidu-sai-esimese-rahasusti-markus-villigult-ja-kaspar-tirilt/',
      source: 'Geenius - Estonian sales startup receives first funding from Markus Villig and Kaspar Tiri.'
    },
    {
      date: '2022-08-18',
      title: 'Eesti tehnoloogiaidu kaasab 56 miljonit ja asub lõhkuma Zuckerbergi lootust ainuvõimule metaversumis',
      url: 'https://ekspress.delfi.ee/artikkel/120051250/eesti-tehnoloogiaidu-kaasab-56-miljonit-ja-asub-lohkuma-zuckerbergi-lootust-ainuvoimule-metaversumis',
      source: 'Eesti Ekspress - Estonian tech startup raises €56M to challenge Zuckerberg\'s metaverse monopoly hopes.'
    },
    {
      date: '2021-01-05',
      title: 'Virtuaalmaailma pealetung: avatarina kooli, kontserdile ja autot ostma',
      url: 'https://parnu.postimees.ee/7147369/virtuaalmaailma-pealetung-avatarina-kooli-kontserdile-ja-autot-ostma',
      source: 'Pärnu Postimees - The virtual world invasion: going to school, concerts, and buying cars as an avatar.'
    },
    {
      date: '2020-08-12',
      title: 'Virtuaalidentiteeti loov Eesti idufirma sai 1,2 miljonit',
      url: 'https://www.aripaev.ee/uudised/2020/08/12/virtuaalidentiteeti-loov-eesti-idufirma-sai-12-miljonit',
      source: 'Äripäev - Estonian startup creating virtual identities raises €1.2 million.'
    },
    {
      date: '2019-11-03',
      title: 'Kolm põhjust, miks ettevõtjad USAs ebaõnnestuvad',
      url: 'https://www.aripaev.ee/uudised/2019/11/03/kolm-pohjust-miks-ettevotjad-usas-ebaonnestuvad',
      source: 'Äripäev - Three reasons why entrepreneurs fail in the USA.'
    },
    {
      date: '2019-04-05',
      title: 'Kaspar Tiri – noor pärnakas Forbes edetabelis',
      url: 'https://arileht.delfi.ee/artikkel/85824851/kaspar-tiri-noor-parnakas-forbes-edetabelis',
      source: 'Delfi - Young entrepreneur from Pärnu makes it to Forbes list.'
    }
  ];

  const podcasts = [
    {
      date: '2019-11-19',
      title: 'The Future of Digital Humans',
      url: 'https://www.youtube.com/watch?v=89sSrofYyGo',
      source: 'AWE - Augmented World Expo talk on the evolution and future of digital human avatars.'
    },
    {
      date: '2019-06-03',
      title: 'Founder Stories: Kaspar Tiri',
      url: 'https://youtu.be/cZEH1uqHHdQ?t=864',
      source: 'L59 - Deep dive into the founder journey, challenges, and lessons learned building Ready Player Me.'
    }
  ];

  return (
    <>
      <Nav />
      
      <header style={{ padding: 0, margin: 0, minHeight: 'auto' }}>
        <div className="container" style={{ paddingTop: '96px', paddingBottom: 0 }}>
          <div className="section-header">
            <h1 style={{ fontSize: '32px', marginTop: 0, marginBottom: '15px', padding: '3px 2px', lineHeight: 1.3 }}>
              Media Appearances
            </h1>
            <p style={{ color: 'var(--accent-color)', fontSize: '16px', lineHeight: 1.6, marginBottom: '10px', padding: '3px 2px' }}>
              Discover news, articles, podcasts, and talks from Kaspar Tiri, where he shares his thoughts and experiences 
              on building startups, navigating go-to-market strategies, and lessons learned along the way.
            </p>
            <p style={{ color: 'var(--accent-color)', fontSize: '14px', fontStyle: 'italic', marginBottom: 0, padding: '3px 2px' }}>
              The list is not a complete archive and will be updated regularly with new content.
            </p>
            <hr style={{ border: 'none', borderTop: '1px solid var(--border-color)', margin: '22px 0' }} />
          </div>
        </div>
      </header>

      <section className="posts" style={{ borderTop: 'none' }}>
        <div className="container">
          <div className="section-header">
            <h2>International News</h2>
          </div>
          <div className="posts-list">
            {internationalNews.map((item, idx) => (
              <article key={idx} className="post-item">
                <div className="post-date">[{item.date}]</div>
                <h3 className="post-title">
                  <a href={item.url} target="_blank" rel="noopener">{item.title}</a>
                </h3>
                <div className="post-excerpt">{item.source}</div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about" style={{ background: 'var(--terminal-bg)' }}>
        <div className="container">
          <div className="section-header">
            <h2>Estonian News</h2>
          </div>
          <div className="posts-list">
            {estonianNews.map((item, idx) => (
              <article key={idx} className="post-item">
                <div className="post-date">[{item.date}]</div>
                <h3 className="post-title">
                  <a href={item.url} target="_blank" rel="noopener">{item.title}</a>
                </h3>
                <div className="post-excerpt">{item.source}</div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="posts">
        <div className="container">
          <div className="section-header">
            <h2>Podcasts & Talks</h2>
          </div>
          <div className="posts-list">
            {podcasts.map((item, idx) => (
              <article key={idx} className="post-item">
                <div className="post-date">[{item.date}]</div>
                <h3 className="post-title">
                  <a href={item.url} target="_blank" rel="noopener">{item.title}</a>
                </h3>
                <div className="post-excerpt">{item.source}</div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

